/**
 * Add an office location to the office location list
 * We create a new list for a provider if they don't already have one
 * We also push the default office location to the top
 *
 * @param {Object} locations
 * @param {Number} defaultOfficeId
 * @param {Object} officeLocation
 */
export const pushOrUnshiftOfficeLocation = (
  locations,
  { defaultOfficeId, officeLocation }
) => {
  if (officeLocation["provider"] in locations) {
    // When office location for a provider already exists
    if (officeLocation["provider_address_id"] === defaultOfficeId) {
      // Add to the top when we find the default office
      locations[officeLocation["provider"]].unshift(officeLocation);
    } else {
      // Add to the bottom for the remaining office locations
      locations[officeLocation["provider"]].push(officeLocation);
    }
  } else {
    // Create new if doesn't exit
    locations[officeLocation["provider"]] = [officeLocation];
  }
};

/**
 * Check if key is part of an object
 * If it is push the value
 * Else set the value
 *
 * @param {Object} obj
 * @param {String} key
 * @param {Array} val
 */
export const setOrPush = (obj, { key, val }) => {
  if (key in obj) {
    obj[key].push(val);
  } else {
    obj[key] = [val];
  }
};
